import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import StoreButtons from "../components/StoreButtons";
import LoadingSpinner from "../components/LoadingSpinner";
import {
  getClickPlatform,
  sanitizeRef,
} from "../utils/openAppRedirect";
import {
  recordReferralClick,
  validateReferralCode,
} from "../services/referrals";

const Referral = () => {
  const { referralCode } = useParams();
  const code = sanitizeRef(referralCode);
  const [state, setState] = useState({
    loading: true,
    valid: false,
  });

  useEffect(() => {
    let cancelled = false;

    if (!code) {
      setState({ loading: false, valid: false });
      return undefined;
    }

    validateReferralCode(code)
      .then((result) => {
        if (cancelled) return;
        setState({ loading: false, valid: Boolean(result.valid) });

        const platform = getClickPlatform({
          userAgent: navigator.userAgent || "",
          platform: navigator.platform || "",
          maxTouchPoints: navigator.maxTouchPoints || 0,
        });
        if (result.valid && platform) {
          recordReferralClick(code, platform).catch(() => {});
        }
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, valid: false });
      });

    return () => {
      cancelled = true;
    };
  }, [code]);

  const seo = {
    title: state.valid
      ? "You’re invited to Azzir | Azzir Events"
      : "Invite link | Azzir Events",
    noindex: true,
    canonicalPath: code ? `/ref/${encodeURIComponent(code)}` : "/ref",
  };

  return (
    <Layout seo={seo}>
      <section className="azzir-not-found azzir-referral">
        <div className="container">
          <div className="azzir-not-found__inner">
            {state.loading ? (
              <LoadingSpinner />
            ) : state.valid ? (
              <>
                <p className="azzir-not-found__eyebrow">Invite</p>
                <h1 className="azzir-not-found__title">You’re invited to Azzir</h1>
                <span className="azzir-not-found__rule" aria-hidden="true" />
                <p className="azzir-not-found__message">
                  Download the Azzir app to join with invite code {code}.
                </p>
                <StoreButtons />
              </>
            ) : (
              <>
                <p className="azzir-not-found__eyebrow">Invite</p>
                <h1 className="azzir-not-found__title">This invite isn’t valid</h1>
                <span className="azzir-not-found__rule" aria-hidden="true" />
                <p className="azzir-not-found__message">
                  This referral link is invalid or no longer available. You can
                  still download Azzir.
                </p>
                <StoreButtons />
              </>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Referral;
